export default "__VITE_ASSET__D_S6RoUI__"